import { render, staticRenderFns } from "./TotalMembersByIndividualPlan.vue?vue&type=template&id=8a79ca7a&"
import script from "./TotalMembersByIndividualPlan.vue?vue&type=script&lang=js&"
export * from "./TotalMembersByIndividualPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports